<template>
  <div id="app">
    <div class="app-wrapper">
      <v-header
        v-if="this.$router.currentRoute.name !== 'Login'"
        :navButton="slideToggle"
        :logo="require('@/assets/signable_cropped_white.svg')"
        logoTooltip="Signable"
        :pageIcon="$route.meta.icon"
        :pageHeader="$route.meta.title"
        :pageSubHeader="$route.meta.subHeader"
        :user="$store.state.user.partner"
        :dropdownMenu="[
            { title: 'Dropdown A', route: '/my-profile' },
            { title: 'Dropdown B', route: '/company-profile' },
            { title: this.$t('pageHeader.dropdownMenu.logout'), action: this.openLogoutModal },
          ]" />
      <v-side-navigation
        v-if="this.$router.currentRoute.name !== 'Login'"
        ref="side-navigation"
        :menu="sideNavigation" />
      <transition name="fade">
        <router-view
          class="router"
          ref="scroll-element"
          id="o-router"></router-view>
      </transition>
    </div>
    <v-notifications />
    <v-dynamic-loader viewURL="modals/LogoutModal" />
  </div>
</template>

<script>
import store from 'store';
import { VHeader, VSideNavigation } from '@signable/ui-kit/src/organisms';
import VNotifications from '@/views/partials/Notifications.vue';

export default {
  name: 'app',
  components: {
    VHeader,
    VSideNavigation,
    VNotifications,
  },
  data() {
    return {
    };
  },
  created() {
    const token = store.get('oauthTokens');
    const partner = store.get('partner');
    if (partner && token) {
      token.user = partner;
      this.$store.commit('user/SET_TOKENS', { token });
    }
  },
  computed: {
    sideNavigation() {
      const start = [{ title: 'Dashboard', route: '/', exact: true, listItemIcon: 'tachometer-alt', inverted: true }];
      const end = [{ title: 'Profile', route: '/profile', listItemIcon: 'handshake', inverted: true }];
      let middle = [];

      if (this.$store.state.user.partner.type === "full") {
        middle = [{ title: 'Subaccounts', route: '/subaccounts', listItemIcon: 'users', inverted: true }];
      } else if (this.$store.state.user.partner.type === "affiliate") {
        middle = [{ title: 'Referrals', route: '/referrals', listItemIcon: 'hands-helping', inverted: true }];
      }

      return start.concat(middle, end);
    }
  },
  methods: {
    openLogoutModal() {
      this.$bus.$emit('toggleModal', { name: 'logout-modal', active: true });
    },
    slideToggle() {
      this.$refs['side-navigation'].slideToggle();
    },
  },
};
</script>

<style lang="scss">
@import '/styles/manifest.scss';

html, body {
  min-height: 100vh;
}

h1 {
  font-size: 28px;
}

a {
  color: $signable-primary-1;
  text-decoration: underline;
  cursor: pointer;
}

.app-wrapper {
  position: relative;
  height: 100vh;
}

.show-feedback {
  height: calc(100vh - 48px);
}

.router {
  position: absolute;
  right: 0;
  width: calc(100% - 240px);
  height: calc(100% - 84px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding: $spacing-base;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media (max-width: 1020px) {
  .router {
    width: 100%;
    margin-top: 124px;
    height: calc(100% - 124px);
  }
}

@media (max-width: 450px) {
  .router {
    padding: $spacing-small;
    margin-top: 96px;
    height: auto;
    top: 0;
  }
}
</style>
